import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MessageDiv from "components/molecules/MessageDiv";
import { useSelectChatBottom } from "modules/hooks";
import { useDispatch, useSelector } from "react-redux";
import {
  isActiveSosongGuideModal,
  isActiveSosongTermSearch,
} from "modules/actions/statusMenu";
import { setMessageId, setSelectedMsgId } from 'modules/actions/quality';

/**
 * Chatting:Middle
 */
const ChatMiddle = () => {
  const chatResult = useSelector((state) => state.chatList);
  const messageSet = chatResult.data;
  const messageBoxRef = useRef();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [doNotScroll, setDoNotScroll] = useState(false);
  const addBtnRef = useState(null);

  const onSosongGuide = () => {
    // if (sideMenuStatus === true) {
    //   dispatch(disableAllMenu());
    // }
    dispatch(isActiveSosongGuideModal());
  };

  const onSosongTermSearch = () => {
    console.log('onSosongTermSearch');
    dispatch(setSelectedMsgId(-1));
    dispatch(isActiveSosongTermSearch());
  };

  const onKeyPressEvt = e => {
    if (e.key === 'Enter') {  
      setDoNotScroll(true);
      setVisible(!visible);
    }
  };

  // 결국엔 useEffect를 풀어서 구현하고 나머지를 어떻게 해야될것같다.
  //  useSelectChatBottom();
  //  onCLick 마치고 false로 바꾼다
  //  setDoNotScroll(false);
  useEffect(() => {
    const msgTop = document.querySelectorAll("._customer_message_div");
    const messageList = document.querySelectorAll(
      ".scroll_style_messenger > div"
    );
      setDoNotScroll(false);
    if (messageList.length > 1 && !doNotScroll) {
      if (
        messageList[messageList.length - 2]
          .getAttribute("name")
          .includes("bot_")
      ) {
        // console.log("scroll bottom!!!!");
        document.getElementById("scrollToElement").scrollTo({
          top: document.getElementById("scrollToElement").scrollHeight,
          behavior: "smooth",
        });
      } else if (msgTop.length > 0) {
        // console.log("scroll focus user!!!!");
        document.getElementById("scrollToElement").scrollTo({
          top: msgTop[msgTop.length - 1].offsetTop - 20,
          behavior: "smooth",
        });
      }
    } 

    if(messageList.length === 0 && !doNotScroll){
      // console.log("scroll top!!!!");
      document.getElementById("scrollToElement").scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [chatResult,visible]);

  return (
    <section className="_chat_middle">
      <div className="_message_div">
        <div
          className="_message_layout scroll_style_messenger"
          id="scrollToElement"
          ref={messageBoxRef}
        >
          {messageSet.map((item, idx) => {
            return (
              <MessageDiv key={item.messageId} message={item} index={idx} />
            );
          })}
        </div>
        <div className="_additional_div">
          {!visible && (
            <span
              className="_addtional_click_tag"
              onClick={() => {
                setDoNotScroll(true);
                setVisible(!visible);
              }}
            >
              {" "}
              <button type="button" className="_addtional_click_open_btn" onKeyPress={onKeyPressEvt} aria-label="부가창 아이콘 펼치기" title="부가창 아이콘 펼치기">
              <img
                src={`${process.env.PUBLIC_URL}/images/svg/additional_main.svg`}
                className="_img additional_click_btn"
                alt=""
                style={{ margin: "0px 0px 1px 8px" }}
              />
              </button>
            </span>
          )}
          {visible && (
            <>
              <span
                className="_addtional_click_tag"
                onClick={() => {
                  setDoNotScroll(true);
                  setVisible(!visible);
                }}
              >
                {" "}
                <button type="button" className="_addtional_click_close_btn" onKeyPress={onKeyPressEvt} aria-label="부가창 아이콘 접기" title="부가창 아이콘 접기">
                <img
                  src={`${process.env.PUBLIC_URL}/images/svg/additional_main.svg`}
                  className="_img additional_click_btn"
                  alt=""
                  style={{
                    margin: "0px 0px 1px 8px",
                    transform: "rotate(180deg)",
                  }}
                />
                </button>
              </span>
              <span onClick={() => onSosongGuide()}>
              <button type="button" onKeyPress={(e) =>{if (e.key === 'Enter') {e.preventDefault(); onSosongGuide()}}} className="_additional_sosong" aria-label="소송절차안내도" title="소송절차안내도">
                <img
                  src={`${process.env.PUBLIC_URL}/images/svg/additional/addtionalSosong.svg`}
                  className="_img"
                  alt=""
                  style={{ margin: "0px 0px 1px 0px" }}
                />{" "}
                </button>
              </span>
              <span onClick={() => onSosongTermSearch()}>
              <button type="button" onKeyPress={(e) =>{if (e.key === 'Enter') {e.preventDefault(); onSosongTermSearch()}}}
              className="_additional_words" aria-label="연관 용어 찾기" title="연관 용어 찾기">
                <img
                  src={`${process.env.PUBLIC_URL}/images/svg/additional/additionalWords.svg`}
                  className="_img"
                  alt=""
                  style={{ margin: "0px 0px 1px 0px" }}
                />{" "}
                </button>
              </span>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ChatMiddle;
